import { useMemo } from "react";
import { Button } from "primereact/button";

import { routes } from "../../common/routing/routes";
import { PropsWithClassName } from "../../common/types/PropsWithClassName";

interface TicketNavigationProps extends PropsWithClassName {
  ticketId: string;
  relatedTicketIds: string[];
}

export default function TicketNavigation({ className, ticketId, relatedTicketIds }: TicketNavigationProps) {
  const { currentIndex, total, navigatePath } = useMemo(() => {
    const index = relatedTicketIds.indexOf(ticketId);
    return {
      currentIndex: index >= 0 ? index : -1,
      total: relatedTicketIds.length,
      navigatePath: routes.agentTicketDetails.navigatePath,
    };
  }, [ticketId, relatedTicketIds]);
  const relatedTicketIdsQueryParams = useMemo(() => `relatedTicketIds=${relatedTicketIds.join(",")}`, [relatedTicketIds]);
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === relatedTicketIds.length - 1;

  const onPrevious = () => {
    if (currentIndex > 0) {
      const previousTicketId = relatedTicketIds[currentIndex - 1];
      window.location.href = `${navigatePath}/${previousTicketId}?${relatedTicketIdsQueryParams}`;
    }
  };

  const onNext = () => {
    if (currentIndex < relatedTicketIds.length - 1) {
      const nextTicketId = relatedTicketIds[currentIndex + 1];
      window.location.href = `${navigatePath}/${nextTicketId}?${relatedTicketIdsQueryParams}`;
    }
  };

  return (
    <div className={`${className} flex align-items-center justify-content-center gap-2`}>
      <Button type="button" size="small" icon="pi pi-chevron-left" severity="secondary" text disabled={isFirst} onClick={onPrevious} />
      <span>
        Tichet {currentIndex + 1} din {total}
      </span>
      <Button type="button" size="small" icon="pi pi-chevron-right" severity="secondary" text disabled={isLast} onClick={onNext} />
    </div>
  );
}
